import { render, staticRenderFns } from "./HomeRelation.vue?vue&type=template&id=13dd2e81&scoped=true"
import script from "./HomeRelation.vue?vue&type=script&lang=js"
export * from "./HomeRelation.vue?vue&type=script&lang=js"
import style0 from "./HomeRelation.vue?vue&type=style&index=0&id=13dd2e81&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13dd2e81",
  null
  
)

export default component.exports